import React from 'react';
import {Button, Input, Modal, notification, Space, Tag} from 'antd';
import {
    DislikeOutlined,
    //DownOutlined,
    HourglassOutlined,
    LikeOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    //RightOutlined
} from '@ant-design/icons';
import {RequestsInterface} from "../../controller/AdminController";
import {HorizontalLayout} from "../../layout/HorizontalLayout";
import {Text} from "../../components/styled/Text";
import {PaperLayout} from "../../components/styled/PaperLayout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHourglassHalf, faThumbsDown, faThumbsUp} from "@fortawesome/free-solid-svg-icons";
import {VerticalLayout} from '../../layout/VerticalLayout';
import Field from "../../components/Field";
import {Flex} from "../../components/styled/Flex";
import {ConfigContext} from "../../context/ConfigurationContext";
import {headerFromToken} from "../../hook/index";
import {useHistory} from "react-router";
import {authFetch} from "../../api/api";
import {useKeycloak} from "@react-keycloak/web";
import {errorMessage} from "../../components/ErrorMessage";

interface RequestControllerInterface {
    request: RequestsInterface;
}

const Status: Record<string, string> = {
    pending: 'In Lavorazione',
    approved: 'Approvato',
    rejected: 'Respinto'
};

export const TagIcon: Record<string, (css?:React.CSSProperties)=>React.ReactElement<any>> = {
    pending: (css?:React.CSSProperties) => <HourglassOutlined style={css}/>,
    approved: (css?:React.CSSProperties) => <LikeOutlined style={css}/>,
    rejected: (css?:React.CSSProperties) => <DislikeOutlined style={css}/>
};

const TagColor: Record<string, string> = {
    pending: 'orange',
    approved: 'green',
    rejected: 'red'
};


export const StatusIcon: Record<string, React.ReactElement<any>> = {
    pending: <FontAwesomeIcon size={'2x'} color={'orange'} icon={faHourglassHalf}/>,
    approved: <FontAwesomeIcon size={'2x'} color={'green'} icon={faThumbsUp}/>,
    rejected: <FontAwesomeIcon size={'2x'} color={'red'} icon={faThumbsDown}/>
};

const TooltipText: Record<string,string> = {
    consentGenRevoke: 'Richiesta revoca consenso test genetici',
    consentFormRevoke: 'Richiesta revoca uso dati anamnestici'
};

/*
const ConsentIcon: Record<string, (css?:React.CSSProperties)=>React.ReactElement<any>> = {
    consentGenRevoke: (css?:React.CSSProperties)=><Tooltip title={TooltipText['consentGenRevoke']}><FontAwesomeIcon style={css} icon={faDna} color={'#d53035'}/></Tooltip>,
    consentFormRevoke: (css?:React.CSSProperties)=><Tooltip title={TooltipText['consentFormRevoke']}><FontAwesomeIcon style={css} icon={faFileContract} color={'#d53035'}/></Tooltip>
};
*/

/*
userEmail: string;
    type: 'consentGenRevoke' | 'consentFormRevoke';
    status: 'pending' | 'approved' | 'rejected';
 description: string;
    created: Date;
    lastUpdate: Date;
 */

/*
<FontAwesomeIcon
                    color={'green'}
                    onClick={()=> {setExpand(!expand)}}
                    size={'2x'}
                    icon={expand?faChevronDown:faChevronRight}
                />
 */

interface MinimalParamsInterface {
    conf: any;
    id: number;
    reason?:string;
}

interface FullParamsInterface extends MinimalParamsInterface {
    action: string;
}

interface ModalAction {
    title: string,
    okText: string,
    action: (kc: Keycloak.KeycloakInstance, params: MinimalParamsInterface) => Promise<any>;
}

const doAction = async (kc: Keycloak.KeycloakInstance, params: FullParamsInterface) => {
    const {id, action,reason, conf} = params;

    const url = `${conf['requestsPath']}/${id}/${action}`;
    const fetchHeader = (kc.authenticated ? {headers: headerFromToken(kc?.token)} : {});


    const theReason = {reason: reason};

    const options = {
        headers: {...fetchHeader.headers},
        method: 'POST',
        body: JSON.stringify(theReason)
    };


    const res = await fetch(url, options as any);
    return res;
};


const reject = async (kc: Keycloak.KeycloakInstance, params: MinimalParamsInterface) => {
    return doAction(kc, {action: 'reject', ...params});
};


const accept = async (kc: Keycloak.KeycloakInstance, params: MinimalParamsInterface) => {
    return doAction(kc, {action: 'approve', ...params});
};


type ActionType = 'accept' | 'reject';
type ActionMap<T> = Record<ActionType,T>;


const ModalConfirm: Record<string, ModalAction> = {
    accept: {title: 'Modifica Consenso: Approvare la richiesta', okText: 'Approva', action: accept},
    reject: {title: 'Modifica Consenso: Rifiutare la richiesta', okText: 'Rifiuta', action: reject}
};

const manageError = (status: number, res: any) => {
    let description = '';
    switch(status) {
        case 400:
            description = 'Richiesta non Valida';
            break;
        case 409:
            description = 'Modifica di una Richiste non in stato "In Lavorazione"';
            break;
        case 404:
            description = 'Messun dato trovato';
            break;
        default:
            description = 'Errore inatteso';
            break;
    }
    notification.error({
        message: 'Richiesta modifica consenso',
        description: description
    });
};

const RequestController: React.FC<RequestControllerInterface> = (props) => {
    const {request} = props;
    const [expand, setExpand] = React.useState(false)
    const [loading, setLoading] = React.useState<ActionMap<boolean>>({accept: false, reject: false});
    //    const [rejectReason, setRejectReason] = React.useState(undefined as (string | undefined));
    // const auth = React.useContext(AuthContext);
    const {keycloak} = useKeycloak();
    const conf = React.useContext(ConfigContext);
    const history = useHistory();
    const {location} = history;
    const expandIcon = (expand?<MinusCircleOutlined style={{color: 'green', fontSize: '1.5rem'}} onClick={()=>setExpand(false)}/>:<PlusCircleOutlined  style={{color: 'green', fontSize: '1.5rem'}}  onClick={()=>setExpand(true)}/>);

    const {innerWidth} = window;

    const handleAction = (act: ActionType) => {
        const {title, action, okText} = ModalConfirm[act];
        let reasonValue = undefined as (string | undefined);
        const content = (act === 'reject') && (
            <VerticalLayout>
                <Field labelWeight={700} labelSize={'1rem'} label={'Motivazione (Obbligatorio)'}>
                    <Input.TextArea
                        onChange={(e) => {
                            reasonValue = e.target.value;
                        }}/>
                </Field>
            </VerticalLayout>
        );

        Modal.confirm({
            title: title,
            okText: okText,
            onOk: () => {
                const v: ActionMap<boolean> =  {accept: (act === 'accept'), reject: (act === 'reject')};
                setLoading(v);
                let error = undefined as (undefined | number);

                if ((reasonValue === undefined) && (act === 'reject')) {

                    Modal.error({
                       title: 'Modifica consenso',
                        content: <p>Il campo motivazioni è obbligatorio per questa operazione</p>,
                        onOk: () => setLoading({accept: false, reject: false})
                    });

                } else {
                    authFetch(keycloak, action, {conf: conf, id: request.id, reason: reasonValue}).then(r => {
                        setLoading({accept: false, reject: false});
                        if (!r.ok) {
                            error = r.status;
                        }
                        return r.json();
                    }).then(res => {
                        if (error !== undefined) {
                            manageError(error, res);
                        } else {
                            notification.info({
                                message: 'Modifca consenso',
                                description: 'Operazione eseguita con successo'
                            });

                            const newStatus = res.status;

                            history.push(location.pathname + `?status=${newStatus}`);

                        }
                    }).catch(e => {
                        setLoading({accept: false, reject: false});
                        notification.info({
                            message: 'Modifca consenso',
                            description: `${errorMessage['900']}`
                        });
                    });
                }
            },
            width: innerWidth/2,
            content: content
        })
    };

    return (
        <PaperLayout asCard={false}>
            <VerticalLayout>
            <Flex direction={'row'} justify={'space-between'}>
                {expandIcon}
                {!expand &&
                    <>
                        <Text>{request.userEmail}</Text>
                    <Tag><Text>{TooltipText[request.type]}</Text></Tag>
                        <Text>{TagIcon[request.status]({fontSize: '1.5rem', color: TagColor[request.status]})}</Text>
                    </>
                    }
            </Flex>
                {
                    expand && (
                        <HorizontalLayout>
                            <VerticalLayout>
                        <Field label={'Email'}>{request.userEmail}</Field>
                        <Field label={'Tipologia'}>{TooltipText[request.type]}</Field>
                        <Field label={'Stato'}><Tag className={'sergen-tag'} style={{fontSize: '1.1rem'}} color={TagColor[request.status]} icon={TagIcon[request.status]()        }>{Status[request.status]}</Tag></Field>
                        <Field label={'Motivazione'}>{request.description}</Field>
                        <Field label={'Data Creazione'}>{Intl.DateTimeFormat('it-IT').format(new Date(request.created))}</Field>
                        <Field label={'Data Ultimo Aggiornamento'}>{Intl.DateTimeFormat('it-IT').format(new Date(request.lastUpdate))}</Field>
                            </VerticalLayout>
                            {request.status === 'pending' &&
                            <Space direction={'vertical'} align={'center'}>
                                <Button
                                    loading={loading['accept']}
                                    type={'text'}
                                    style={{
                                        fontSize: '1.2rem',
                                        border: '1px solid green',
                                        color: 'green',
                                        paddingTop: '0px',
                                        paddingLeft: '10px',
                                        paddingRight: '10px',
                                        paddingBottom: '10px'
                                    }}
                                    icon={<LikeOutlined style={{fontSize: '1.2rem'}}/>}
                                    onClick={() => handleAction('accept')}
                                >
                                    Approva
                                </Button>

                                <Button
                                    loading={loading['reject']}
                                    type={'text'}
                                    style={{
                                        fontSize: '1.2rem',
                                        border: '1px solid #d53035',
                                        color: '#d53035',
                                        paddingTop: '0px',
                                        paddingLeft: '10px',
                                        paddingRight: '10px',
                                        paddingBottom: '10px'
                                    }}
                                    icon={<DislikeOutlined/>}
                                    onClick={() => handleAction('reject')}
                                >
                                    Rifiuta
                                </Button>
                            </Space>
                            }
                        </HorizontalLayout>
                    )
                }
            </VerticalLayout>
        </PaperLayout>
    )
};
export default RequestController;